<template>
    <div>
        <!--ヘルプボタン-->
        <div class="pc"><div @click="openModal" class="help_btn" :class="{hidden: help_btn_pc_is_hidden}"><img src="../assets/images/help_btn.svg" alt="HELPボタン"></div></div>
        <div class="sp"><div @click="openModal" class="footer_help_btn_sp" :class="{hidden: help_btn_pc_is_hidden}"><img src="../assets/images/footer_help_btn_sp.svg" alt="HELPボタン"></div></div>
        <!--ヘルプボタン_モーダル-->
        <!--ヘルプtopページ-->
        <div v-if="showModal == '1'" @close="showModal = false" :key="1">
            <div class="modal-mask">
                <div class="modal-wrapper" @click.self="$emit('close')">
                    <div class="modal-container modal_top">
                        <div class="modal-body">
                            <div class="center">
                                <div class="closeBtn" @click="closeModal"><img src="../assets/images/help_closebtn.svg" alt="HELP閉じるボタン"></div>
                                <!--モーダル内-->
                                <div class="sp_position">
                                    <img class="help_top_img" src="../assets/images/help_top_image.svg" alt="すきカモ">
                                    <img class="help_tittle" src="../assets/images/help_tittle.svg" alt="すきカモ！の使い方">
                                    <div class="start_btn" @click="showModal = 2">
                                        <img class="" src="../assets/images/help_start.svg" alt="STARTボタン">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--ヘルプ2～13ページ-->
        <div v-else-if="showModal == '2' || showModal == '3' ||showModal == '4' ||showModal == '5' ||showModal == '6' ||showModal == '7' ||showModal == '8' ||showModal == '9' ||showModal == '10' ||showModal == '11' ||showModal == '12' ||showModal == '13'">
            <div class="modal-mask">
                <div class="modal-wrapper" @click.self="$emit('close')">
                    <div class="modal-container">
                        <div class="modal-body">
                            <div class="center">
                                <div class="closeBtn" @click="closeModal"><img class="pc" src="../assets/images/help_closebtn.svg" alt="HELP閉じるボタン"><img class="sp" src="../assets/images/help_closebtn_sp.svg" alt="HELP閉じるボタン"></div>
                                <!--モーダル内-->
                                <!--ヘルプ2ページ目-->
                                <div v-if="showModal == '2'" @close="closeModal" :key="2">
                                    <img class="" src="../assets/images/help_pagination01-1.svg" alt="ページ">
                                    <div class="sp_position">
                                        <div class="modal_text01">すきカモ！な写真を探してみよう</div>
                                        <div class="modal_text02">気になる画像をクリック。<br class="sp">画像の詳細が見れるよ！</div>
                                        <img class="help_img02" src="../assets/images/help_image01-1.png" srcset="../assets/images/help_image01-1.png 1x, ../assets/images/help_image01-1@2x.png 2x" alt="説明画像">
                                    </div>
                                    <div>
                                        <div class="leftBtn" @click="showModal = 1">
                                            <img class="non-selected_prev-btn" src="../assets/images/help_prev.svg" alt="戻るボタン">
                                            <img class="selected_prev-btn" src="../assets/images/help_prev_hover.svg" alt="戻るボタン">
                                        </div>
                                        <div class="rightBtn" @click="showModal = 3">
                                            <img class="non-selected_next-btn" src="../assets/images/help_next.svg" alt="次へボタン">
                                            <img class="selected_next-btn" src="../assets/images/help_next_hover.svg" alt="次へボタン">
                                        </div>
                                    </div>
                                </div>
                                <!--ヘルプ3ページ目-->
                                <div v-if="showModal == '3'" @close="closeModal" :key="3">
                                    <img class="" src="../assets/images/help_pagination01-2.svg" alt="ページ">
                                    <div class="sp_position">
                                        <div class="modal_text01">すきカモ！な写真を探してみよう</div>
                                        <div class="modal_text02">虫眼鏡マークから商品の詳細をチェック！</div>
                                        <img class="help_img03" src="../assets/images/help_image01-2.png" srcset="../assets/images/help_image01-2.png 1x, ../assets/images/help_image01-2@2x.png 2x" alt="説明画像">
                                    </div>
                                    <div>
                                        <div class="leftBtn" @click="showModal = 2">
                                            <img class="non-selected_prev-btn" src="../assets/images/help_prev.svg" alt="戻るボタン">
                                            <img class="selected_prev-btn" src="../assets/images/help_prev_hover.svg" alt="戻るボタン">
                                        </div>
                                        <div class="rightBtn" @click="showModal = 4">
                                            <img class="non-selected_next-btn" src="../assets/images/help_next.svg" alt="次へボタン">
                                            <img class="selected_next-btn" src="../assets/images/help_next_hover.svg" alt="次へボタン">
                                        </div>
                                    </div>
                                </div>
                                <!--ヘルプ4ページ目-->
                                <div v-if="showModal == '4'" @close="closeModal" :key="4">
                                    <img class="" src="../assets/images/help_pagination01-3.svg" alt="ページ">
                                    <div class="sp_position">
                                        <div class="modal_text01">すきカモ！な写真を探してみよう</div>
                                        <div class="modal_text02">すきカモ！と思ったら画像をリストに追加！</div>
                                        <img class="help_img04" src="../assets/images/help_image01-3.png" srcset="../assets/images/help_image01-3.png 1x, ../assets/images/help_image01-3@2x.png 2x" alt="説明画像">
                                    </div>
                                    <div>
                                        <div class="leftBtn" @click="showModal = 3">
                                            <img class="non-selected_prev-btn" src="../assets/images/help_prev.svg" alt="戻るボタン">
                                            <img class="selected_prev-btn" src="../assets/images/help_prev_hover.svg" alt="戻るボタン">
                                        </div>
                                        <div class="rightBtn" @click="showModal = 5">
                                            <img class="non-selected_next-btn" src="../assets/images/help_next.svg" alt="次へボタン">
                                            <img class="selected_next-btn" src="../assets/images/help_next_hover.svg" alt="次へボタン">
                                        </div>
                                    </div>
                                </div>
                                <!--ヘルプ5ページ目-->
                                <div v-if="showModal == '5'" @close="closeModal" :key="5">
                                    <img class="" src="../assets/images/help_pagination01-4.svg" alt="ページ">
                                    <div class="sp_position">
                                        <div class="modal_text01">すきカモ！な写真を探してみよう</div>
                                        <div class="modal_text02">デジカタで<br class="sp">壁紙のコーディネートを見てみよう！</div>
                                        <img class="help_img05" src="../assets/images/help_image01-4.png" srcset="../assets/images/help_image01-4.png 1x, ../assets/images/help_image01-4@2x.png 2x" alt="説明画像">
                                    </div>
                                    <div>
                                        <div class="leftBtn" @click="showModal = 4">
                                            <img class="non-selected_prev-btn" src="../assets/images/help_prev.svg" alt="戻るボタン">
                                            <img class="selected_prev-btn" src="../assets/images/help_prev_hover.svg" alt="戻るボタン">
                                        </div>
                                        <div class="rightBtn" @click="showModal = 6">
                                            <img class="non-selected_next-btn" src="../assets/images/help_next.svg" alt="次へボタン">
                                            <img class="selected_next-btn" src="../assets/images/help_next_hover.svg" alt="次へボタン">
                                        </div>
                                    </div>
                                </div>
                                <!--ヘルプ6ページ目-->
                                <div v-if="showModal == '6'" @close="closeModal" :key="6">
                                    <img class="" src="../assets/images/help_pagination02-1.svg" alt="ページ">
                                    <div class="sp_position">
                                        <div class="modal_text01">好きなスタイルや部屋別で<br class="sp">絞り込もう</div>
                                        <img class="help_img06" src="../assets/images/help_image02-1.png" srcset="../assets/images/help_image02-1.png 1x, ../assets/images/help_image02-1@2x.png 2x" alt="説明画像">
                                    </div>
                                    <div>
                                        <div class="leftBtn" @click="showModal = 5">
                                            <img class="non-selected_prev-btn" src="../assets/images/help_prev.svg" alt="戻るボタン">
                                            <img class="selected_prev-btn" src="../assets/images/help_prev_hover.svg" alt="戻るボタン">
                                        </div>
                                        <div class="rightBtn" @click="showModal = 7">
                                            <img class="non-selected_next-btn" src="../assets/images/help_next.svg" alt="次へボタン">
                                            <img class="selected_next-btn" src="../assets/images/help_next_hover.svg" alt="次へボタン">
                                        </div>
                                    </div>
                                </div>
                                <!--ヘルプ7ページ目-->
                                <div v-if="showModal == '7'" @close="closeModal" :key="7">
                                    <img class="" src="../assets/images/help_pagination02-2.svg" alt="ページ">
                                    <div class="sp_position">
                                        <div class="modal_text01">好きなスタイルや部屋別で<br class="sp">絞り込もう</div>
                                        <div class="modal_text02">写真を見て気になったキーワードを<br>クリックしてみよう！</div>
                                        <img class="help_img07" src="../assets/images/help_image02-2.png" srcset="../assets/images/help_image02-2.png 1x, ../assets/images/help_image02-2@2x.png 2x" alt="説明画像">
                                    </div>
                                    <div>
                                        <div class="leftBtn" @click="showModal = 6">
                                            <img class="non-selected_prev-btn" src="../assets/images/help_prev.svg" alt="戻るボタン">
                                            <img class="selected_prev-btn" src="../assets/images/help_prev_hover.svg" alt="戻るボタン">
                                        </div>
                                        <div class="rightBtn" @click="showModal = 8">
                                            <img class="non-selected_next-btn" src="../assets/images/help_next.svg" alt="次へボタン">
                                            <img class="selected_next-btn" src="../assets/images/help_next_hover.svg" alt="次へボタン">
                                        </div>
                                    </div>
                                </div>
                                <!--ヘルプ8ページ目-->
                                <div v-if="showModal == '8'" @close="closeModal" :key="8">
                                    <img class="" src="../assets/images/help_pagination03-1.svg" alt="ページ">
                                    <div class="sp_position">
                                        <div class="modal_text01">すきカモ！な写真を保存しよう</div>
                                        <div class="modal_text02">写真の上のハートマークを押して<br>リストに追加しよう！</div>
                                        <img class="help_img08" src="../assets/images/help_image03-1.png" srcset="../assets/images/help_image03-1.png 1x, ../assets/images/help_image03-1@2x.png 2x" alt="説明画像">
                                    </div>
                                    <div>
                                        <div class="leftBtn" @click="showModal = 7">
                                            <img class="non-selected_prev-btn" src="../assets/images/help_prev.svg" alt="戻るボタン">
                                            <img class="selected_prev-btn" src="../assets/images/help_prev_hover.svg" alt="戻るボタン">
                                        </div>
                                        <div class="rightBtn" @click="showModal = 9">
                                            <img class="non-selected_next-btn" src="../assets/images/help_next.svg" alt="次へボタン">
                                            <img class="selected_next-btn" src="../assets/images/help_next_hover.svg" alt="次へボタン">
                                        </div>
                                    </div>
                                </div>
                                <!--ヘルプ9ページ目-->
                                <div v-if="showModal == '9'" @close="closeModal" :key="9">
                                    <img class="" src="../assets/images/help_pagination03-2.svg" alt="ページ">
                                    <div class="sp_position">
                                        <div class="modal_text01">すきカモ！な写真を保存しよう</div>
                                        <div class="modal_text02">施工したいお部屋ごとに<br class="sp">リストを作成すると便利！</div>
                                        <img class="help_img09" src="../assets/images/help_image03-2.png" srcset="../assets/images/help_image03-2.png 1x, ../assets/images/help_image03-2@2x.png 2x" alt="説明画像">
                                    </div>
                                    <div>
                                        <div class="leftBtn" @click="showModal = 8">
                                            <img class="non-selected_prev-btn" src="../assets/images/help_prev.svg" alt="戻るボタン">
                                            <img class="selected_prev-btn" src="../assets/images/help_prev_hover.svg" alt="戻るボタン">
                                        </div>
                                        <div class="rightBtn" @click="showModal = 10">
                                            <img class="non-selected_next-btn" src="../assets/images/help_next.svg" alt="次へボタン">
                                            <img class="selected_next-btn" src="../assets/images/help_next_hover.svg" alt="次へボタン">
                                        </div>
                                    </div>
                                </div>
                                <!--ヘルプ10ページ目-->
                                <div v-if="showModal == '10'" @close="closeModal" :key="10">
                                    <img class="" src="../assets/images/help_pagination03-3.svg" alt="ページ">
                                    <div class="sp_position">
                                        <div class="modal_text01">すきカモ！な写真を保存しよう</div>
                                        <div class="modal_text02">自分のすきカモ！を振り返ろう！</div>
                                        <img class="help_img10" src="../assets/images/help_image03-3.png" srcset="../assets/images/help_image03-3.png 1x, ../assets/images/help_image03-3@2x.png 2x" alt="説明画像">
                                    </div>
                                    <div>
                                        <div class="leftBtn" @click="showModal = 9">
                                            <img class="non-selected_prev-btn" src="../assets/images/help_prev.svg" alt="戻るボタン">
                                            <img class="selected_prev-btn" src="../assets/images/help_prev_hover.svg" alt="戻るボタン">
                                        </div>
                                        <div class="rightBtn" @click="showModal = 11">
                                            <img class="non-selected_next-btn" src="../assets/images/help_next.svg" alt="次へボタン">
                                            <img class="selected_next-btn" src="../assets/images/help_next_hover.svg" alt="次へボタン">
                                        </div>
                                    </div>
                                </div>
                                <!--ヘルプ11ページ目-->
                                <div v-if="showModal == '11'" @close="closeModal" :key="11">
                                    <img class="" src="../assets/images/help_pagination04-1.svg" alt="ページ">
                                    <div class="sp_position">
                                        <div class="modal_text01">マイホームできたカモを使おう</div>
                                        <div class="modal_text02">すきカモリストの中から、<br class="sp">さらにピックアップして<br>お家まるごと一軒の<br class="sp">コーディネートをしてみよう！</div>
                                        <img class="help_img11" src="../assets/images/help_image04-1.png" srcset="../assets/images/help_image04-1.png 1x, ../assets/images/help_image04-1@2x.png 2x" alt="説明画像">
                                    </div>
                                    <div>
                                        <div class="leftBtn" @click="showModal = 10">
                                            <img class="non-selected_prev-btn" src="../assets/images/help_prev.svg" alt="戻るボタン">
                                            <img class="selected_prev-btn" src="../assets/images/help_prev_hover.svg" alt="戻るボタン">
                                        </div>
                                        <div class="rightBtn" @click="showModal = 12">
                                            <img class="non-selected_next-btn" src="../assets/images/help_next.svg" alt="次へボタン">
                                            <img class="selected_next-btn" src="../assets/images/help_next_hover.svg" alt="次へボタン">
                                        </div>
                                    </div>
                                </div>
                                <!--ヘルプ12ページ目-->
                                <div v-if="showModal == '12'" @close="closeModal" :key="12">
                                    <img class="" src="../assets/images/help_pagination04-2.svg" alt="ページ">
                                    <div class="sp_position">
                                        <div class="modal_text01">マイホームできたカモを使おう</div>
                                        <div class="modal_text02">マイホームできたカモに追加した写真は<br>右下のボタンから一覧で見られるよ！</div>
                                        <img class="help_img12" src="../assets/images/help_image04-2.png" srcset="../assets/images/help_image04-2.png 1x, ../assets/images/help_image04-2@2x.png 2x" alt="説明画像">
                                    </div>
                                    <div>
                                        <div class="leftBtn" @click="showModal = 11">
                                            <img class="non-selected_prev-btn" src="../assets/images/help_prev.svg" alt="戻るボタン">
                                            <img class="selected_prev-btn" src="../assets/images/help_prev_hover.svg" alt="戻るボタン">
                                        </div>
                                        <div class="rightBtn" @click="showModal = 13">
                                            <img class="non-selected_next-btn" src="../assets/images/help_next.svg" alt="次へボタン">
                                            <img class="selected_next-btn" src="../assets/images/help_next_hover.svg" alt="次へボタン">
                                        </div>
                                    </div>
                                </div>
                                <!--ヘルプ13ページ目-->
                                <div v-if="showModal == '13'" @close="closeModal" :key="13">
                                    <img class="" src="../assets/images/help_pagination04-3.svg" alt="ページ">
                                    <div class="sp_position">
                                        <div class="modal_text01">マイホームできたカモを使おう</div>
                                        <div class="modal_text02">コーディネーターさんとの<br>打ち合わせなどの参考に是非使ってね！</div>
                                        <img class="help_img13" src="../assets/images/help_image04-3.png" srcset="../assets/images/help_image04-3.png 1x, ../assets/images/help_image04-3@2x.png 2x" alt="説明画像">
                                    </div>
                                    <div>
                                        <div class="leftBtn" @click="showModal = 12">
                                            <img class="non-selected_prev-btn" src="../assets/images/help_prev.svg" alt="戻るボタン">
                                            <img class="selected_prev-btn" src="../assets/images/help_prev_hover.svg" alt="戻るボタン">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import Util from '../assets/js/Util'

    export default {
        name: "Help",
        computed: {
            ...mapState('search', ['search_conditions']),
            ...mapState(["is_sp"]),
        },
        data: () => ({
            showModal: false,//モーダル
            isFixed: false,
            help_btn_pc_is_hidden: false,
            callback: () => {}
        }),
        mounted() {
            const app = document.getElementById('app');
            const help_btn_pc = this.$el.querySelector('.pc .help_btn');
            const help_btn_sp = this.$el.querySelector('.sp .footer_help_btn_sp');
            this.callback = () => this.help_btn_pc_is_hidden = !Util.detectCollision(app, this.is_sp ? help_btn_sp : help_btn_pc);
            window.addEventListener('scroll', this.callback);
            this.callback();
        },
        destroyed() {
            window.removeEventListener('scroll', this.callback);
        },

        methods: {
            openModal(){
                this.showModal = 1;
                this.isFixed = true;
                // this.scrollY = window.scrollY;
                document.body.classList.add('fixed')
            },
            closeModal(){
                this.showModal = false;
                document.body.classList.remove('fixed')
            },
        },
    }
</script>

<style scoped lang="scss">
    .fixed {
        overflow-y:hidden;
    }
    /*ヘルプボタン*/
    .help_btn {
        position: fixed;
        bottom: 70px;
        transition: 0.3s ease;
        &.hidden{
            opacity: 0;
            visibility: hidden;
        }
    }
    .help_btn:hover {
        opacity: 0.7;
        cursor: pointer;
    }

    /*モーダル*/
    .modal-mask {
        position: fixed;
        z-index: 99;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }
    .modal-wrapper {
        height: 100%;
        display: flex;
        align-items: center;
    }
    .modal-container {
        width: 480px;
        height: 520px;
        /*margin: 3rem auto;*/
        margin: 10rem auto;
        padding: 1.5rem 2rem;
        text-align: center;
        background: #ffffff;
        box-sizing: border-box;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        border-radius: 10px;
        position: relative;
    }
    .modal_top {
        background-color: #eddfb2;
        padding: 0 20px;
    }
    /*モーダルテキスト*/
    .modal_text01,
    .modal_text02 {
        color: #826e67;
    }
    .modal_text01 {
        font-size: 20px;
        font-weight: bold;
        margin: 40px 0 15px;
    }
    .modal_text02 {
        font-size: 16px;
        margin: 0 0 35px;
    }
    /*閉じるボタン*/
    .closeBtn {
        width: 30px;
        height: 30px;
        position: absolute;
        top: -45px;
        right: 0;
    }
    .closeBtn img {
        width: 30px;
        height: 30px;
    }
    .closeBtn:hover {
        cursor: pointer;
    }
    /*ヘルプTOPページすきカモ画像*/
    .help_top_img {
        margin: 80px 0 0;
    }
    /*ヘルプTOPページタイトル画像*/
    .help_tittle {
        margin: 35px 0 0;
    }
    /*ヘルプ各ページ説明画像*/
    .help_img03 {
        margin-top: -3px;
    }
    .help_img04 {
        margin: -32px 0 0 32px;
    }
    .help_img05 {
        margin: 0 0 0 10px;
    }
    .help_img06 {
        margin: 25px 0 0 0;
    }
    .help_img07 {
        margin: -10px 0 0 40px;
    }
    .help_img08 {
        margin: -30px 0 0 30px;
    }
    .help_img09 {
        margin: 0 0 0 20px;
    }
    .help_img10 {
        margin: -10px 0 0 0;
    }
    .help_img11 {
        margin: -25px 0 0 20px;
    }
    .help_img12 {
        margin: 0 0 0 25px;
    }
    .help_img13 {
        margin: 0 0 0 25px;
    }

    /*スタートボタン*/
    .start_btn {
        background-color: white;
        border: solid 2px #826e67;
        border-radius: 5px;
        padding: 8.5px 0;
        margin: 55px 0 0;
    }
    .start_btn:hover {
        cursor: pointer;
    }
    /*戻るボタン*/
    .non-selected_prev-btn {
        position: absolute;
        left: 10px;
        bottom: 40%;
    }
    .non-selected_prev-btn:hover {
        opacity: 0;
    }
    .selected_prev-btn {
        position: absolute;
        left: 10px;
        bottom: 40%;
        opacity: 0;
    }
    .selected_prev-btn:hover {
        opacity: 1;
        cursor: pointer;
    }
    /*次へボタン*/
    .non-selected_next-btn {
        position: absolute;
        right: 10px;
        bottom: 40%;
    }
    .non-selected_next-btn:hover {
        opacity: 0;
    }
    .selected_next-btn {
        position: absolute;
        right: 10px;
        bottom: 40%;
        opacity: 0;
    }
    .selected_next-btn:hover {
        opacity: 1;
        cursor: pointer;
    }

    /*.myhome_sukikamo {*/
    /*    opacity: 1;*/
    /*}*/
    .help_btn{
        opacity: 1;
    }
    /*.myhome_sukikamo.fade-out {*/
    /*    opacity: 0;*/
    /*    transition: opacity 1s;*/
    /*}*/
    .help_btn.fade-in {
        opacity: 0;
        transition: opacity 1s;
    }

    /*sp用-----------------------------------------------------------------------------------*/
    @media only screen and (max-width: 639px) {
        /*ヘルプボタン*/
        .footer_help_btn_sp {
            background-color: transparent;
            border: none;
            cursor: pointer;
            outline: none;
            padding: 0;
            appearance: none;
            position: fixed;
            bottom: 10px;
            z-index: 20;
            transition: 0.3s ease;
            &.hidden{
                opacity: 0;
                visibility: hidden;
            }
        }
        .footer_help_btn_sp img {
            height: 45px;
            vertical-align: middle;
        }
        /*閉じるボタン*/
        .closeBtn {
            width: 30px;
            height: 30px;
            position: absolute;
            top: 10px;
            right: 15px;
        }
        .closeBtn img {
            width: 30px;
            height: 30px;
        }
        /*モーダル*/
        .modal-mask {
            z-index: 99;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .5);
            display: table;
            transition: opacity .3s ease;
        }
        .modal-wrapper {
            position: fixed;
            width: 100%;
            height: calc(100% - 60px);
            /*height: 100%;*/
            display: flex;
            align-items: center;
            margin-top: 60px;
        }
        .modal-container {
            width: 100%;
            height: 100%;
            max-width: initial;
            margin: 0 auto;
            padding: 55px 15px 18px;
            text-align: center;
            background: #ffffff;
            box-sizing: border-box;
            transition: all .3s ease;
            border-radius: 0;
            position: relative;
        }
        .modal_text01 {
            font-size: 20px;
            font-weight: bold;
            margin: 30px 0 15px;
        }
        .modal_text02 {
            font-size: 16px;
            margin: 0 0 25px;
        }
        .sp_position {
            width: 340px;
            margin: 0 auto;
            /*<!--position: absolute;-->*/
            /*<!--top: 50%;-->*/
            /*<!--left: 50%;-->*/
            /*<!--transform: translateY(-50%) translateX(-50%);-->*/
        }
        .modal_top {
            background-color: #eddfb2;
        }
        /*ヘルプTOPページすきカモ画像*/
        .help_top_img {
            margin: 40px 0 0;
        }
        /*ヘルプTOPページタイトル画像*/
        .help_tittle {
            width: 90%;
            margin: 50px 0 0;
        }
        .start_btn {
            margin: 45px 0 0;
        }
        /*ヘルプ各ページ説明画像*/
        .help_img02,
        .help_img03,
        .help_img04,
        .help_img05,
        .help_img06,
        .help_img07,
        .help_img08,
        .help_img09,
        .help_img10,
        .help_img11,
        .help_img12,
        .help_img13 {
            width: 85%;
        }
        .help_img04 {
            margin: -25px 0 0 10px;
            /*width: 98%;*/
        }
        .help_img05 {
            margin: 0 0 0 10px;
            /*width: 98%;*/
        }
        .help_img06 {
            margin: 5px 0 0 0;
        }
        .help_img07 {
            margin: 0;
        }
        .help_img08 {
            margin: 0 0 0 10px;
            /*width: 98%;*/
        }
        .help_img09 {
            margin: 0;
            /*width: 98%;*/
        }
        .help_img10 {
            margin: 0;
        }
        .help_img11 {
            margin: -20px 0 0 0;
            /*width: 98%;*/
        }
        .help_img12 {
            margin: 0 0 0 10px;
        }
        .help_img13 {
            margin: 0;
        }
        /*戻るボタン*/
        .non-selected_prev-btn {
            left: 15px;
            bottom: 18px;
        }
        .selected_prev-btn {
            left: 15px;
            bottom: 18px;
        }
        /*次へボタン*/
        .non-selected_next-btn {
            right: 15px;
            bottom: 18px;
        }
        .selected_next-btn {
            right: 15px;
            bottom: 18px;
        }
    }
</style>
